// extracted by mini-css-extract-plugin
module.exports = {"section":"RecipePairings_section__GOtpb","headline":"RecipePairings_headline__ihnor","grid":"RecipePairings_grid__wewo2"};